import React from 'react';
import { FadeIn } from './Shared';
export const UrgencyBar = () => {
  return <div className="bg-rose-light border-y border-rose/20 py-6" data-id="element-169">
      <div className="max-w-4xl mx-auto px-6 md:px-8" data-id="element-170">
        <FadeIn data-id="element-171">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-172">
            <div className="flex items-center gap-3" data-id="element-173">
              <span className="text-2xl" data-id="element-174">🔥</span>
              <div data-id="element-175">
                <h4 className="font-bold text-rose-hover" data-id="element-176">
                  Promoción por tiempo limitado
                </h4>
                <p className="text-sm text-rose-hover/80 flex items-center gap-1" data-id="element-177">
                  <span className="text-xs" data-id="element-178">⚠</span> Cupos disponibles
                  agotándose
                </p>
              </div>
            </div>

            <div className="w-full md:w-64" data-id="element-179">
              <div className="flex justify-between text-xs font-bold text-rose-hover mb-1" data-id="element-180">
                <span data-id="element-181">Tomado</span>
                <span data-id="element-182">80%</span>
              </div>
              <div className="w-full bg-rose/20 rounded-full h-2.5" data-id="element-183">
                <div className="bg-rose h-2.5 rounded-full" style={{
                width: '80%'
              }} data-id="element-184"></div>
              </div>
            </div>

            <div className="text-center md:text-right" data-id="element-185">
              <p className="text-sm font-bold text-rose-hover" data-id="element-186">
                Últimos accesos a<br className="hidden md:block" data-id="element-187" /> precio
                promocional.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </div>;
};